import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Table as StapTable } from 'reactstrap'

export const Table = ({ items = [] }) => {
  const { t } = useTranslation()

  return (
    <div className="table-responsive mb-4">
      <StapTable className={`table mb-0 table-bordered`}>
        <tbody>
          {items.map(({ label, Cell }, i) => (
            <tr key={i}>
              <th scope="row">{label}:</th>
              <td>{Cell && Cell()}</td>
            </tr>
          ))}
        </tbody>
      </StapTable>
    </div>
  )
}

Table.propTypes = {
  items: PropTypes.array,
}
